import { c as _c } from "react/compiler-runtime";
import { SphereActionDivider } from "@components/common/sphere-action-divider";
import { CreditViewMode } from "@custom-types/credit-types";
import { ToggleGroup } from "@flat-ui";
import { ExportTransactionsOrPurchases } from "@pages/settings/subscription-settings/credits/export-transactions-or-purchases";
import { creditTransactionsSelector, fetchingTransactionsFlagsSelector } from "@store/credit-transactions/credit-transactions-selector";
import { allCreditSubscriptionsSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
/**
 * List of possible view options for the dialog.
 * It is used for the toggle view component.
 */
const VIEW_OPTIONS = [{
  label: "Transactions",
  value: CreditViewMode.transaction
}, {
  label: "Purchases",
  value: CreditViewMode.purchases
}];

/** Renders additional top right actions for the credits dialog */
export function CreditsDialogTopRightActions(t0) {
  const $ = _c(12);
  const {
    currentViewMode,
    setViewMode
  } = t0;
  const {
    trackEvent
  } = useTrackEvent();
  const transactions = useAppSelector(creditTransactionsSelector);
  const {
    status
  } = useAppSelector(fetchingTransactionsFlagsSelector);
  const subscriptions = useAppSelector(allCreditSubscriptionsSelector);
  const isTransactionsView = currentViewMode === CreditViewMode.transaction;
  const shouldShowExportButton = isTransactionsView ? transactions.length > 0 || status === "pending" : subscriptions.length > 0;
  let t1;
  if ($[0] !== setViewMode || $[1] !== trackEvent) {
    t1 = function handleViewModeChange(newMode) {
      trackEvent({
        name: newMode === CreditViewMode.transaction ? WorkspaceEvents.viewCreditsTransactions : WorkspaceEvents.viewCreditsPurchaseHistory,
        props: {
          origin: "credits-dialog"
        }
      });
      setViewMode(newMode);
    };
    $[0] = setViewMode;
    $[1] = trackEvent;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const handleViewModeChange = t1;
  let t2;
  if ($[3] !== currentViewMode || $[4] !== handleViewModeChange) {
    t2 = <ToggleGroup items={VIEW_OPTIONS} onChange={handleViewModeChange} value={currentViewMode} />;
    $[3] = currentViewMode;
    $[4] = handleViewModeChange;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== isTransactionsView || $[7] !== shouldShowExportButton) {
    t3 = shouldShowExportButton && <><SphereActionDivider /><ExportTransactionsOrPurchases isTransactionsView={isTransactionsView} /><SphereActionDivider /></>;
    $[6] = isTransactionsView;
    $[7] = shouldShowExportButton;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] !== t2 || $[10] !== t3) {
    t4 = <>{t2}{t3}</>;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}